const EstadoEnum = {
    SIN_STOCK: {
        est_id: -1,
        est_codigo: "sin_stock"
    },
    INACTIVO: {
        est_id: 0,
        est_codigo: "inactivo"
    },
    ACTIVO: {
        est_id: 1,
        est_codigo: "activo"
    },
    REGISTRADO: {
        est_id: 2,
        est_codigo: "registrado"
    },
    CREADO: {
        est_id: 3,
        est_codigo: "creado"
    },
    POR_APROBAR: {
        est_id: 4,
        est_codigo: "por_aprobar"
    },
    APROBADO: {
        est_id: 5,
        est_codigo: "aprobado"
    },
    DESAPROBADO: {
        est_id: 6,
        est_codigo: "desaprobado"
    },
    EMITIDO: {
        est_id: 7,
        est_codigo: "emitido"
    },
    CANCELADO: {
        est_id: 8,
        est_codigo: "cancelado"
    },
    DEPOSITADO: {
        est_id: 9,
        est_codigo: "depositado"
    },
    PAGADO_PARCIAL: {
        est_id: 10,
        est_codigo: "pago_parcial"
    },
    PAGADO: {
        est_id: 11,
        est_codigo: "pagado"
    },
    ASIGNADO: {
        est_id: 12,
        est_codigo: "asignado"
    },
    POR_DEVOLVER: {
        est_id: 23,
        est_codigo: "por_devolver"
    },
    ELIMINADO: {
        est_id: 24,
        est_codigo: "eliminado"
    },
    INGRESO_CONFIRMADO: {
        est_id: 25,
        est_codigo: "ingreso_confirmado"
    },
    INGRESO_PARCIAL: {
        est_id: 26,
        est_codigo: "ingreso_parcial"
    },
    EN_DESPACHO: {
        est_id: 27,
        est_codigo: "en_despacho"
    },
    PENDIENTE: {
        est_id: 28,
        est_codigo: "pendiente"
    },
    EN_CARGUIO: {
        est_id: 29,
        est_codigo: "en_carguio"
    },
    EN_RUTA: {
        est_id: 30,
        est_codigo: "en_ruta"
    },
    DESCARGANDO: {
        est_id: 31,
        est_codigo: "descargando"
    },
    EN_RETORNO: {
        est_id: 32,
        est_codigo: "en_retorno"
    },
    COMPLETADO: {
        est_id: 33,
        est_codigo: "completado"
    },
    EN_PROCESO: {
        est_id: 34,
        est_codigo: "en_proceso"
    },
    PROGRAMADO: {
        est_id: 35,
        est_codigo: "programado"
    },
    ATENDIDO_PARCIAL: {
        est_id: 37,
        est_codigo: "atendido_parcial",
    },
    ATENDIDO: {
        est_id: 36,
        est_codigo: "atendido",
    },

}

export default EstadoEnum